import CheckoutAppliedPromo from './checkout-applied-promo';
import template from './templates/checkout-promo';
import { context as defaultContext } from './checkout-defaults';
import store from '@stores/cart/cart-store';

const CLASS_NAME_FORM_VALIDATED = 'was-validated';

const DEFAULT_OPTIONS = {
    replaceOriginEl: false
};

export default class CheckoutPromo {
    constructor($originEl, context, options) {
        context = { ...defaultContext, ...context };
        options = { ...DEFAULT_OPTIONS, ...options };

        const $parsed = $( $.parseHTML(template) );
        this.$el = $parsed;
        this.$originEl = $originEl;

        this.$applyLabel = this.$el.find('[data-label="apply"]');
        this.$codeLabel = this.$el.find('[data-label="code"]');

        this.$error = this.$el.find('[data-region="error"]');

        this.$apply = this.$el.find('[data-control="apply"]');
        this.$form = this.$el.find('[data-control="form"]');
        this.$input = this.$el.find('[data-control="input"]');

        this.$appliedPromo = this.$el.find('[data-region="appliedPromo"]');

        this.appliedPromo = null;

        this.replaceOriginEl = options.replaceOriginEl;

        this.context = context;

        this.init();
    }

    init() {
        this.renderLabels();
        this.renderAppliedPromo();
        this.renderCode();
        this.setupListeners();
    }

    async onSubmit(evt) {
        evt.preventDefault();
        
        this.validationReset();

        const form = this.$form.get(0);

        if(form.checkValidity()) {
            const { success, data, error } = await store.actions.applyPromo(this.$input.val());

            if(!success && error) {
                this.$error.show().html(error);
            } else if(!data?.Valid) {
                this.$error.show().html(this.context.PromoCodeInvalid);
            }
        } else {
            this.validate();
        }
    }

    render() {
        if(this.$originEl) {
            this.replaceOriginEl ? this.$originEl.replaceWith(this.$el) : this.$originEl.html(this.$el);
        }

        return this.$el;
    }
    
    renderAppliedPromo() {
        const context = {
            applied: this.context.PromoApplied,
            remove: this.context.RemovePromoSrText
        };

        this.appliedPromo = new CheckoutAppliedPromo(this.$appliedPromo, context, {
            bordered: true
        });

        this.appliedPromo.render();
    }

    renderCode() {
        this.$code
    }

    renderLabels() {
        this.$applyLabel.html(this.context.Apply);
        this.$codeLabel.html(this.context.PromoCode);
        this.$input.attr('placeholder', this.context.PromoCode);
    }

    setupListeners() {
        this.$form.on('submit', (evt) => this.onSubmit(evt));

        store.watch('promoCode', () => this.updateCode());
    }

    updateCode() {
        if(store.state.promoCode) {
            this.$appliedPromo.show();
        } else {
            this.$appliedPromo.hide();
        }
    }

    validate() {
        this.$form.addClass(CLASS_NAME_FORM_VALIDATED);
        this.$error.show().html(this.context.PromoCodeRequired);

        this.$input
            .attr('aria-invalid', true)
            .on('input', () => {
                const invalid = this.$input.is(':invalid');
                this.$input.attr('aria-invalid', invalid);
            });

        this.$input.get(0).focus();
    }

    validationReset() {
        this.$form.removeClass(CLASS_NAME_FORM_VALIDATED);
        this.$error.hide();
    }
};
